import { type CustomTooltipProps } from "ag-grid-react"
import { Card, CardContent } from "~/components/reusable/Card"
import { Warning } from "@phosphor-icons/react"
import { formatName } from "~/utils/namingUtils"

export default function NoForecastTooltip(props: CustomTooltipProps) {
  if (props.location === "header") {
    return null
  }

  // Two separate reasons a cell has no percentage. Beyond the horizon means the forecast array
  // stops short of this period; no demand means the forecast reaches it and is zero there.
  if (props.value?.noDemand && !props.value?.forecastUnavailable) {
    return (
      <Card className="w-[300px]">
        <CardContent className="flex items-start gap-2 py-3">
          <Warning className="text-orange-500 shrink-0" size={20} />
          <div>
            <p className="font-medium text-fg-base">No expected demand</p>
            <p className="text-fg-subtle text-sm mt-1">
              Availability is the share of expected demand that stock can cover. This period has
              none, so there is nothing to measure.
            </p>
          </div>
        </CardContent>
      </Card>
    )
  }

  if (!props.value?.forecastUnavailable) {
    return null
  }

  return (
    <Card className="w-[300px]">
      <CardContent className="flex items-start gap-2 py-3">
        <Warning className="text-orange-500 shrink-0" size={20} />
        <div>
          <p className="font-medium text-fg-base">No demand data</p>
          <p className="text-fg-subtle text-sm mt-1">
            Availability is only calculated from closing stock. Expected demand is needed for
            realistic availability projections.
          </p>
          <div className="text-fg-subtle text-sm mt-1">
            <p>The missing demand might be due to:</p>
            <ul className="list-disc list-inside">
              <li>Product not activated at current date</li>
              <li>Demand period being too far into the future</li>
            </ul>
          </div>
          <p className="text-fg-subtle text-sm mt-1">
            The missing demand might be due to it being a new product, and we lack sufficient{" "}
            {formatName("sale", true)} data to produce a reliable longer demand projection.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
